import { GarantieModel } from "src/app/core/models/garantie-model";
import { ProvisionOutput } from "./ProvisionOutput";

export class DossierProvision {
  garanties: GarantieModel[];
  etatProvisionCreances: any[];
  currentEtatCreance: any;
  montantGarantie: number;
  provisionNC: number;
  provisionPR: number;
  pourcentageNC: number;
  pourcentagePR: number;
  provisionTotale: number;
  selectedRule: string;
}


